import styled from "styled-components";

export const Container = styled.form`
  display: flex;
  gap: 16px;
  border-top: 1px solid ${({ theme }) => theme.colors.colorsNew.gray[300]};
  padding: 16px;
  gap: 12px;
`;
